module.exports = __webpack_public_path__ + "media/images/icon-cocomite-manual-4e0d7c41df2ab2d54b71615fe16bd266.svg";